import { createFileRoute } from '@tanstack/react-router'
import { TypesExportPage } from '../../../components/TypesExportPage'

export const Route = createFileRoute('/$org/types/export')({
  component: TypesExport,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      property_uid: (search.property_uid as string) || undefined,
    }
  },
})

function TypesExport() {
  const searchParams = Route.useSearch()
  return <TypesExportPage propertyUID={searchParams.property_uid} />
}